import { ColumnDef } from "@tanstack/react-table";
import { DetailedUser } from "@/user/user.d";

export const ReferralCodeCol = (): ColumnDef<DetailedUser> => ({
  header: "Referral Code",
  accessorKey: "referral_code",
  cell: ({ getValue }) => {
    const referralCode = getValue() as number;
    return <>Referral{referralCode}</>;
  },
  size: 150,
  minSize: 150,
});
